import React, { Fragment } from 'react';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import { AdditionalInformationBox } from '@/ui/components/shared/additional-information-box/additional-information-box';
import {
  RichTextFragment,
  TileFragmentFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { ProductHighlightTab } from './product-highlight-tab/product-highlight-tab';
import { ProductAlternativeModel } from '../types/ProductAlternativeModel';

interface ProductAlternativeModelsSectionProps {
  sectionHeading?: RichTextFragment;
  alternativeProductModels: ProductAlternativeModel[];
  currentProductPath: string;
  displayOnlyCurrentProduct?: boolean;
  openAdditionalInformation?: (tiles?: TileFragmentFragment[], boxId?: string) => void;
  closeAdditionalInformation?: () => void;
  activeBoxId?: string;
}

export function ProductAlternativeModelsSection({
  sectionHeading,
  alternativeProductModels,
  currentProductPath,
  displayOnlyCurrentProduct,
  openAdditionalInformation,
  closeAdditionalInformation,
  activeBoxId,
}: Readonly<ProductAlternativeModelsSectionProps>) {
  const productsToDisplay = displayOnlyCurrentProduct
    ? alternativeProductModels?.filter((model) => model.path === currentProductPath)
    : alternativeProductModels;

  return (
    <div className="space-y-4">
      <RichTextRenderer className="text-xl" blocks={sectionHeading} />

      {productsToDisplay?.map((alternativeProductModel) => (
        <Fragment key={alternativeProductModel.path}>
          <ProductHighlightTab
            isSelected={alternativeProductModel.path === currentProductPath}
            product={alternativeProductModel}
          />
          <AdditionalInformationBox
            additionalInformation={alternativeProductModel}
            activeBoxId={activeBoxId}
            onSelect={(boxId) => {
              openAdditionalInformation?.(
                alternativeProductModel.additionalInformationTiles,
                boxId,
              );
            }}
            onClear={() => {
              closeAdditionalInformation?.();
            }}
          />
        </Fragment>
      ))}
    </div>
  );
}
